// removed by extract-text-webpack-plugin
module.exports = {"search":"bc_be","backgroundContainer":"bc_bf","section":"bc_k","header":"bc_bg bc_k","categories":"bc_bh bc_k","signUpPrompt":"bc_bi bc_k","partners":"bc_bj","heading":"bc_i","partnerList":"bc_bk _2HU8ZgmfpIdsUwklJ4Ng6B _3JIEYde9anI6O5H5wYv2ik","popular":"bc_bl"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Homepage/styles.module.css
// module id = 1236
// module chunks = 27